import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c92d060e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label", "onKeydown"]
const _hoisted_2 = { class: "row first" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "row second" }
const _hoisted_5 = { class: "info-wrapper" }
const _hoisted_6 = { class: "sub-title" }
const _hoisted_7 = { class: "description" }
const _hoisted_8 = { class: "info-wrapper" }
const _hoisted_9 = { class: "sub-title" }
const _hoisted_10 = { class: "description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "row-wrapper",
    role: "link",
    tabindex: "0",
    "aria-label": `${$props.lostFound.title} 상세 페이지로 이동`,
    onClick: $setup.emitOnClickRow,
    onKeydown: [
      _withKeys(_withModifiers($setup.emitOnClickRow, ["prevent"]), ["enter"]),
      _withKeys(_withModifiers($setup.emitOnClickRow, ["prevent"]), ["space"])
    ]
  }, [
    _createElementVNode("section", _hoisted_2, [
      (!!$props.lostFound.statusName)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["status", [$setup.lostFoundStatusCodeMap[$props.lostFound.statusCode]]])
          }, [
            _createElementVNode("span", null, _toDisplayString($props.lostFound.statusName ?? ""), 1 /* TEXT */)
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("p", _hoisted_3, _toDisplayString($props.lostFound.title), 1 /* TEXT */)
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("p", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(`${$setup.typeText}일시`), 1 /* TEXT */),
        _createElementVNode("span", _hoisted_7, _toDisplayString($setup.lostFoundDateTime), 1 /* TEXT */)
      ]),
      _createElementVNode("p", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, _toDisplayString(`${$setup.typeText}노선`), 1 /* TEXT */),
        _createElementVNode("span", _hoisted_10, _toDisplayString($setup.lostFoundLineName), 1 /* TEXT */)
      ])
    ])
  ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1))
}